import {
  OverridableUserLabel,
  UserLabelOverrideAction,
  UserLabelOverrideInput,
  Operation,
} from '../../../__generated__/globalTypes'

import updateUserLabelOverridesString from '../UpdateUserLabelOverrides.graphql'

export type UpdateUserLabelOverridesData = {
  updateUserLabelOverrides: {
    overrides: {
      label: OverridableUserLabel
      action: UserLabelOverrideAction
    }[]
  }
}

export type UpdateUserLabelOverridesVariables = {
  overrides: UserLabelOverrideInput[]
}

export type UpdateUserLabelOverrides = Operation<
  UpdateUserLabelOverridesData,
  UpdateUserLabelOverridesVariables
>

export const UpdateUserLabelOverrides = ({
  overrides,
}: UpdateUserLabelOverridesVariables): UpdateUserLabelOverrides => ({
  query: updateUserLabelOverridesString,
  variables: {
    overrides: overrides.map(x => UserLabelOverrideInput(x)),
  },
})
